import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import request from './request'
import persistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    request,
  },
  getters:{
    jwtToken: state => state.request.jwtToken,
    appId: state => state.request.appId
  },
  plugins: [persistedState({
      reducer(store) {
        const { jwtToken, ...res } = store.request;
        return {
          request: res,
        }
      }
    })]
})
